import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import HolidayImportForm from 'components/organismos/master/labor/HolidayImportForm';

const HolidayImportPage: React.FC = () => (
  <SidebarTemplate pageTitle="祝日設定">
    <HolidayImportForm />
  </SidebarTemplate>
);

export default HolidayImportPage;
